import script from "./review-mechanism.vue?vue&type=script&lang=tsx"
export * from "./review-mechanism.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__